import type { Session } from '@supabase/supabase-js';
import { createContext, use } from 'react';

export type SessionState =
  { status: 'loading' } | { status: 'signedOut' } | { status: 'signedIn'; session: Session };

/** Kept apart from the provider component so React Fast Refresh stays reliable. */
export const SessionContext = createContext<SessionState | null>(null);

export function useSession(): SessionState {
  const state = use(SessionContext);
  if (!state) {
    throw new Error('useSession must be used inside <SessionProvider>');
  }
  return state;
}
